import AudioCatalog from '@/components/audio-catalog';
import { IconMap } from '@/lib/constants';

export default function NatuurgeluidenPage() {
  return (
    <AudioCatalog
      contentType="nature_sound"
      contentNickname="Natuurgeluiden"
      contentDescription="Rustgevende geluiden uit de natuur om je te helpen ontspannen, te concentreren of in slaap te vallen."
      contentIcon={<IconMap.nature_sound className="h-8 w-8 text-green-500" />}
      pageKey="natuurgeluiden"
    />
  );
}
